<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="row position-relative">

                <div class="col-12">

                    <h1 class="h3">
                                <span>
                                    {{ currentVariation.texts.name1 }}
                                </span>
                    </h1>
                    <hr>
                </div>


                <div class="col-12 col-sm-6">
                    <slot name="image-carousel"></slot>
                </div>

                <div class="col-12 col-sm-6">
                    <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
                        <slot name="rating-stars-dropzone"></slot>
                        <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                    </div>

                    <!-- Variation -->
                    <div class="mb-3" v-show="attributes.length || Object.keys(units).length">
                        <variation-select></variation-select>
                    </div>
                    <!-- /Variation -->

                    <!-- Item Bundle -->
                    <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                                 :bundle-type="currentVariation.variation.bundleType"
                                 :bundle-components="currentVariation.bundleComponents"></item-bundle>
                    <!-- /Item Bundle -->

                    <slot name="before-price"></slot>

                    <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                        <order-property-list></order-property-list>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <item-price :show-cross-price="true"></item-price>
                        </div>
                        <div class="col-6 d-flex align-items-center">
                            <ul id="uvpSingleItem" class="small">
                                <li><i aria-hidden="true" class="fa fa-check"></i> 100 Tage Rückgaberecht</li>
                                <li><i aria-hidden="true" class="fa fa-check"></i> Trusted-Shops Käuferschutz</li>
                                <li><i aria-hidden="true" class="fa fa-check"></i> Kauf auf Rechnung</li>
                            </ul>
                        </div>
                    </div>


                    <slot name="after-price"></slot>

                    <item-availability></item-availability>

                    <graduated-prices></graduated-prices>


                    <div class="mt-3 d-print-none">
                        <div class="w-100">
                            <slot name="before-add-to-basket"></slot>
                        </div>

                        <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                            {{ $translate("Ceres::Template.singleItemSetInfo") }}
                        </div>
                        <div v-else class="position-relative">
                            <add-to-basket
                                    :variation-id="currentVariation.variation.id"
                                    :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                    :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                    :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                    :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                    :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                    :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                    :has-order-properties="currentVariation.hasOrderProperties"
                                    :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                    :use-large-scale="false"
                                    :show-quantity="true"
                                    :item-url="currentVariation | itemURL"
                                    :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                    :has-price="currentVariation | hasItemDefaultPrice"
                            >
                            </add-to-basket>
                            <lazy-img :image-url="$ceres.basePath + '/images/template/trustedshops.png'"
                                      id="atb-seal"
                                      alt="Trusted Shops geprüfter Onlineshop mit Käuferschutz"></lazy-img>
                        </div>

                        <div class="w-100 d-flex mt-3 flex-wrap justify-content-center after-atb">
                            <slot name="after-add-to-basket"></slot>
                        </div>

                    </div>


                    <!-- ./ITEM DETAIL -->

                    <div v-if="currentVariation.prices.default.price.value > 99">
                        <slot name="additional-content-after-add-to-basket"></slot>
                    </div>

                    <slot name="installment-promo"></slot>

                    <slot name="additional-content-after-vat"></slot>
                    <!-- END SINGLEITEM_DETAILS -->
                    <div class="text-center mt-3 font-weight-bold"
                         v-show="currentVariation.prices.default.price.value > 80">
                        <span>- oder telefonisch beraten lassen  -</span><br>
                        <a href="tel:0931/8041133"><i aria-hidden="true" class="fa fa-phone"></i> 0931-8041133
                            anrufen</a>
                    </div>
                </div>

                <slot name="crossselling-accessory"></slot>

                <div class="col-12 col-sm-12 col-md-8 mt-5" id="description">
                    <div class="description">
                        <!-- ITEM DESCRIPTION -->
                        <slot name="description"></slot>
                        <br>
                        <div class="d-flex flex-wrap justify-content-between align-items-center">
                            <b class="articlenumber small">
                                {{ $translate("Ceres::Template.singleItemNumber") }}: {{
                                currentVariation.variation.number }}
                            </b>
                        </div>

                    </div>
                    <!-- ./ITEM DESCRIPTION -->

                    <!--<div v-for="(group, index1) in currentVariation.variationProperties"
                         v-if="group.id === 3">
                        <div class="video-container" v-for="(property, index2) in group.properties"
                             v-if="property.id === 18">
                            <iframe :src="'https://www.youtube-nocookie.com/embed/' + property.values.value"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </div>
                    </div>-->
                </div>

                <div class="col-md-4 col-12 text-center mt-5">
                    <lazy-img picture-class="img-rounded jaeger"
                              :image-url="$ceres.basePath + '/images/template/gerold-profil.jpg'"
                              alt="Gerold Jäger - Inhaber Motivationsgeschenke.de"></lazy-img>
                    <br>
                    <span><b>Grüß Gott,</b> ich bin Gerold Jäger.<br>Bei Fragen, schreiben Sie mir gerne eine </span>
                    <span class="text-primary"><i class="fa fa-envelope" aria-hidden="true"></i> <a class="text-primary" style="text-decoration: underline" target="_blank" href="https://www.motivationsgeschenke.de/kontakt">Nachricht über unser Kontaktformular</a></span>
                </div>


                <slot name="crossselling-similar"></slot>

                <slot name="last-seen"></slot>

                <slot name="ratings-dropzone"></slot>

            </div>
        </slot>
    </div>
</template>

<script>
    import {get} from "../../helper/get";
    import {isNullOrUndefined} from "../../helper/utils";

    export default {

        name: "single-item",

        props: {
            pleaseSelectOptionVariationId: {
                type: Number,
                default: 0
            },
            initPleaseSelectOption: {
                type: Boolean,
                default: false
            },
            showNetPrices: {
                type: Boolean,
                default: false
            },
            isWishListEnabled: {
                type: Boolean,
                default: false
            },
            itemId: {
                type: Number,
                required: true
            },
            afterKey: Object
        },

      jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
      ],


      provide() {
            return {
                itemId: this.$props.itemId
            };
        },


        computed:
            {
                itemConfig() {
                    return App.config.item.itemData;
                },

                isDescriptionTabActive() {
                    return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                        && !!this.currentVariation.texts.description.length;
                },

                isRecommendedPriceActive() {
                    return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
                },

                isShortDescriptionActive() {
                    return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
                },

                hasShippingCostsCategoryId() {
                    return App.config.global.shippingCostsCategoryId > 0;
                },

                isTechnicalDataTabActive() {
                    return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                        && !!this.currentVariation.texts.technicalData.length;
                },

                variationGroupedProperties() {
                    return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
                },

                variationMissingProperties() {
                    return this.$store.getters[`${this.itemId}/variationMissingProperties`];
                },

                currentVariation() {
                    return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
                },

                isVariationSelected() {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
                },

                attributes() {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
                },

                units() {
                    return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
                },

              isItemSet() {
                return this.$store.state.items.isItemSet;
              }
            },

        created() {
            this.$store.dispatch("initVariation", this.itemData);
            this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
        },
      mounted()
      {
        this.$nextTick(() =>
        {
          this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
            itemId:             this.itemId,
            attributes:         this.attributesData,
            variations:         this.variations,
            initialVariationId: this.currentVariation.variation.id,
            isPleaseSelectOption: this.initPleaseSelectOption,
            afterKey:           this.afterKey
          });
          if (this.isItemSet)
          {
            this.$store.dispatch("initSetComponents", this.itemData);
          }
        })
        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
        },

        methods:
            {
                getDataField(field) {
                    return get(this.currentVariation, field);
                },

                getFilteredDataField(field, filter) {
                    if (!isNullOrUndefined(this.$options.filters[filter])) {
                        return this.$options.filters[filter](this.getDataField(field));
                    }

                    return this.getDataField(field);
                },
              // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
              hydrateChildren(nodes)
              {
                nodes.forEach(component => {
                  if (component.$options.name === "lazy-hydrate")
                  {
                    component.hydrate();
                  }
                  else if (component.$children.length)
                  {
                    this.hydrateChildren(component.$children);
                  }
                })
                }
            }
    };
</script>
